<script lang="ts">
  import Button from "$ui/button/button.svelte";
  import type { Component, Snippet } from "svelte";
  import PendingDot from "$assets/icons/pending-dot.svelte";
  import CompleteTick from "$assets/icons/complete-tick.svelte";

  interface Props {
    children: Snippet;
    header: Snippet;

    onBack?: () => void;
    onNext?: () => void;
    onFinish?: () => void;
    currentStep: number;

    steps: { label: string; component: Component }[];
  }

  const { children, onBack, onFinish, onNext, currentStep, header, steps }: Props = $props();
</script>

<div class="flex flex-col h-[calc(100vh-var(--banner-height))]">
  <div class="flex w-full p-4 bg-white justify-between">
    {@render header()}
    <div class="flex items-center gap-4 font-medium">
      {#each steps as step, i}
        <div class="flex gap-2 items-center">
          {#if i > currentStep}
            <PendingDot />
          {:else if i === currentStep}
            {@const CurrentComponent = steps[currentStep].component}
            <CurrentComponent />
          {:else}
            <CompleteTick />
          {/if}
          <span>{step.label}</span>
        </div>
        {#if i !== steps.length - 1}
          <div class="w-10 border border-gray-500"></div>
        {/if}
      {/each}
    </div>
  </div>
  <div class="grow px-6 lg:px-10 py-5 sm:py-8 lg:py-10 overflow-auto">
    {@render children()}
  </div>

  <div class="flex justify-between bg-white p-4">
    {#if onBack}
      <Button on:click={onBack}>Back</Button>
    {:else}
      <div></div>
    {/if}
    <div class="flex items-center gap-2">
      {#if onNext}
        <Button on:click={onNext}>Next</Button>
      {:else if onFinish}
        <Button on:click={onFinish}>Finish</Button>
      {/if}
    </div>
  </div>
</div>
